/**
 * Store: Product form drawer
 * -----------------------------------------------------------------------------
 * Handles product form drawer actions
 */

export default {
  namespaced: true,

  state: () => ({
    product: false,
    config: {
      strings: {
        return: '',
        back: '',
      },
      location: {},
      bisNamespace: '',
    },
    showOnSuccess: false,
  }),

  mutations: {

    /**
     * Set state property.
     */
    SET_CONFIG(state, config = {}) {
      state.config = {
        ...state.config,
        ...config || {},
      }
    },

    /**
     * Set state property.
     */
    SET_PRODUCT(state, product = false) {
      state.product = product
    },

    /**
     * Set showOnSuccess property.
     */
    SET_SHOW_ON_SUCCESS(state, show = false) {
      state.showOnSuccess = show
    },
  },

  actions: {

    /**
      * Set product data.
      * @param {Object} product - Product object.
      */
    setConfig({ commit }, config = {}) {
      commit('SET_CONFIG', config)
    },

    /**
      * Set product data.
      * @param {Object} product - Product object.
      */
    setProductFormDrawerProduct({ commit }, product = false) {
      commit('SET_PRODUCT', product)
    },

    /**
      * Set show data.
      * @param {Boolean} show
      */
    setShowOnSuccess({ commit }, show = false) {
      commit('SET_SHOW_ON_SUCCESS', show)
    },
  },
}
